import { Immutable } from "immer";
import React, { type JSX } from "react";

import { ConfiguratorTypes } from "../../../constants";
import { WebPageURL } from "../../../models/nominals";
import { DropdownRootProductSelector } from "../DropdownRootProductSelector";
import { PanelRootProductSelector } from "../PanelRootProductSelector";
import { RadioRootProductSelector } from "../RadioRootProductSelector";
import { RootProductSelectorInputType } from "../constants";
import { IModularConfiguratorOptionSet } from "../models";

type IProps = Immutable<{
    optionSet: IModularConfiguratorOptionSet;
    chatLinkComponent?: JSX.Element | null;
    liveChatHeader?: string;
    financingLink?: WebPageURL;
    isPlpPanelStyle?: boolean;
    useCompareDrawerCenter?: boolean;
}>;

export const RootProductSelector = (props: IProps): React.JSX.Element => {
    const { useCompareDrawerCenter, ...restProps } = props;

    if (
        restProps.optionSet.layout.design === ConfiguratorTypes.PANEL &&
        !restProps.isPlpPanelStyle
    ) {
        return <PanelRootProductSelector {...restProps} />;
    }
    if (
        restProps.optionSet.root_product_selector.input_type ===
        RootProductSelectorInputType.RADIO
    ) {
        return (
            <RadioRootProductSelector
                {...restProps}
                isPlpPanelStyle={props.isPlpPanelStyle}
                useCompareDrawerCenter={useCompareDrawerCenter}
            />
        );
    }
    return <DropdownRootProductSelector {...restProps} />;
};
